import * as actionTypes from "../actionTypes";
export const initCompanions = (payload) => ({
    type: actionTypes.INIT_GET_AI_COMPANIONS,
    data: payload
});
export const getCompanions = (payload) => ({
    type: actionTypes.GET_AI_COMPANIONS,
    payload: payload
});

export const getCompanionsSuccess = (payload) => ({
    type: actionTypes.GET_AI_COMPANIONS_SUCCESS,
    payload: payload
});
export const getCompanionsSingleSuccess = (payload) => ({
    type: actionTypes.GET_AI_COMPANIONS_SINGLE_SUCCESS,
    payload: payload
});
export const getCompanionsError = () => ({
    type: actionTypes.GET_AI_COMPANIONS_ERROR,
});
export const chatLoadSuccess = () => ({
    type: actionTypes.CHAT_LOAD_SUCCESS,
});

export const clearMsgCompanions = () => ({
    type: actionTypes.CLEAR_AI_COMPANIONS_CHAT,
});
export const sendMsgCompanions = (payload) => ({
    type: actionTypes.SEND_AI_COMPANIONS_CHAT,
    payload: payload
});
export const addNewMsgCHat = (payload) => ({
    type: actionTypes.ADD_NEW_AI_COMPANIONS_CHAT,
    payload: payload
});
export const getChatHistorySuccess = (payload) => ({
    type: actionTypes.GET_AI_COMPANIONS_CHAT_HISTORY_SUCCESS,
    payload: payload
});
export const getChatHistoryError = () => ({
    type: actionTypes.GET_AI_COMPANIONS_CHAT_HISTORY_ERROR,
});
export const initChatHistory = (payload) => ({
    type: actionTypes.INIT_GET_AI_COMPANIONS_CHAT_HISTORY,
    payload: payload
});
export const getChatCompanionsSuccess = (payload) => ({
    type: actionTypes.SEND_AI_COMPANIONS_CHAT_SUCCESS,
    payload: payload
});
export const getChatCompanionsError = (payload) => ({
    type: actionTypes.SEND_AI_COMPANIONS_CHAT_ERROR,
    payload
});

export const aiCompanionsChatStreamStart = () => ({
    type: actionTypes.AI_COMPANIONS_CHAT_STREAM_START,
});
export const aiCompanionsChatStreamDelta = (fullText) => ({
    type: actionTypes.AI_COMPANIONS_CHAT_STREAM_DELTA,
    payload: fullText,
});
export const aiCompanionsChatStreamDone = (payload) => ({
    type: actionTypes.AI_COMPANIONS_CHAT_STREAM_DONE,
    payload,
});
export const addDateChat = () => ({
    type: actionTypes.ADD_DATE_AI_CHAT,
    payload: formatDate(),
});

const formatDate = () => {
    const now = new Date();
    const date = now.toLocaleDateString("en-US", {
        weekday: "long", // Monday
        year: "numeric", // 2025
        month: "long", // February
        day: "numeric", // 25
    });
    const time = now.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true, // 3:44 PM format
    });
    return `${date} | ${time}`;
};

export const removeChatHistoryLoaded = (payload) => ({
    type: actionTypes.REMOVE_CHAT_HISTORY_LOADED,
    payload
});

/** Update feedback for one AI message (thumbs up/down). Payload: { agentId, message_id, feedback: "up" | "down" } */
export const updateChatFeedback = (payload) => ({
    type: actionTypes.UPDATE_AI_COMPANIONS_CHAT_FEEDBACK,
    payload
});
export const updateChatFeedbackSuccess = (payload) => ({
    type: actionTypes.UPDATE_AI_COMPANIONS_CHAT_FEEDBACK_SUCCESS,
    payload
});